import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="8"
    height="11"
    viewBox="0 0 8 11"
    fill="currentColor"
    stroke="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M0.851562 10.7422C1.22656 10.7109 1.48438 10.6432 1.625 10.5391C1.84375 10.3828 2.02344 10.0573 2.16406 9.5625L4.125 2.48438C4.19792 2.19792 4.2474 1.9974 4.27344 1.88281C4.29948 1.76302 4.3125 1.64583 4.3125 1.53125C4.3125 1.27604 4.22917 1.10156 4.0625 1.00781C3.89583 0.908854 3.60156 0.846354 3.17969 0.820312V0.5625H7.14062V0.820312C6.71875 0.877604 6.42708 0.96875 6.26562 1.09375C6.10938 1.21354 5.96354 1.51562 5.82812 2L3.86719 9.07812C3.79948 9.32812 3.75 9.53385 3.71875 9.69531C3.69271 9.85677 3.67969 9.97917 3.67969 10.0625C3.67969 10.3229 3.77083 10.4974 3.95312 10.5859C4.14062 10.6745 4.41406 10.7266 4.77344 10.7422V11H0.851562V10.7422Z" />
  </svg>
);
